





















































































































































import { uuid } from 'vue-uuid'
import { Component, Prop, Vue } from 'vue-property-decorator'
import draggable from 'vuedraggable'

import IQuestion from '@/models/IQuestion'
import IAnswer from '@/models/IAnswer'

import IBranch from '@/components/icons/IBranch.vue'
import ITrash from '@/components/icons/ITrash.vue'
import IRoundCross from '@/components/icons/IRoundCross.vue'
import QuestionBoxEditDialog from './QuestionBoxEditDialog.vue'
import QuestionVoxBranchDialog from './QuestionBoxBranchDialog.vue'

import {EventBus} from '@/event-bus'
import IDraggableParams from '@/models/IDraggableParams'
import IComment from '@/components/icons/IComment.vue';
import Tooltip from '@/components/UI/Tooltip.vue';

@Component({
  name: 'c-question-box',

  components: {
    IComment,
    draggable,
    'c-question-box-edit-dialog': QuestionBoxEditDialog,
    'c-question-box-branch-dialog': QuestionVoxBranchDialog,
    'i-branch': IBranch,
    'i-trash': ITrash,
    'i-round-cross': IRoundCross,
    Tooltip
  },
})
export default class QuestionBox extends Vue {
  @Prop() question!: IQuestion

  @Prop({type: Array, default: () => []}) allQuestions!: IQuestion[]

  @Prop({type: Array, default: () => []}) questions!: IQuestion[]

  @Prop({type: String, default: null}) parentId!: string | null

  // Data
  addAnswerState: boolean = false
  addBranchedAnswer: boolean = false
  branchQsProps = {
    title: '',
    answerId: '' as string,
    ids: [] as string[]
  }

  // Computed
  get answerTitle () {

    let title
    if (this.question.type === 'text') {
      title = this.$t('survey.questionBox.answerTitle.text')
    } else {
      title = this.$t('survey.questionBox.answerTitle.number')
    }

    if (this.question.type === 'select') {
      if (this.question.specify === 'single') {
        title = this.$t('survey.questionBox.answerTitle.singleSelect')
      } else {
        title = this.$t('survey.questionBox.answerTitle.multiSelect')
      }
    }

    return title
  }
  get questionTitle () {
    return this.question.text
  }
  get isImportant () {
    return this.question.important
  }
  get questionType () {
    return this.question.type
  }
  get answers (): any[] {
    const answers = [...this.question.answers]

    return answers.sort((a: any, b: any) => {
      if (a.order > b.order) {
        return 1
      } else if (a.order < b.order) {
        return -1
      }

      return 0
    })
  }
  get qustionsWithoutBranch (): IQuestion[] {
    /**
     * Достаем все id из answer вопросов, чтобы провести выборку
     * вопросов, которые мы можем использовать для ветвления
     */
    const exceptIDArr: string[] = this.allQuestions.reduce((accumulator: string[], v: IQuestion) => {
      const answersIds: string[] = v.answers.reduce((accumulator: string[], v: IAnswer) => {
        if (v.includeQuestions && v.includeQuestions instanceof Array) {
          return [...accumulator, ...v.includeQuestions]
        }

        return accumulator
      }, [] as string[])

      return [...accumulator, ...answersIds]
    }, [] as string[])

    /**
     * Вычитаем из получившегося массива ID, includeQuestions, которые присутствуют
     * в выбранном ответе, чтобы айдишники, которые мы выберем присутствовали
     * при редактировании ветвления, также исключаем parentId, чтобы мы не
     * могли ссылаться на родительский вопрос
     */
    const workedIdsArr = exceptIDArr.filter((v: string) => !this.branchQsProps.ids.includes(v))

    return this.allQuestions
      .filter((v: IQuestion) => !workedIdsArr.includes(v.id) && v.id !== this.parentId)
  }

  // Methods
  changeAnswersOrder (params: IDraggableParams) {
    const oldIndexId = params.moved.element.id
    const newIndex = params.moved.newIndex
    const newIndexId = this.question.answers[newIndex].id


    this.$emit('changeAnswersOrder', {questionId: this.question.id, oldIndexId, newIndexId})
  }
  deleteAnswer (id: string) {
    this.$emit('deleteAnswer', {answerId: id, questionId: this.question.id})
  }
  removeBranchBySubtitle (includeId: string) {
    const answerId = (
      this.question.answers
        .find(v => (v.includeQuestions as string[]).includes(includeId)) as IAnswer
    ).id

    EventBus.$emit('removeQuestionFromBranch', {
      answerId,
      questionId: this.question.id,
      includeId
    })
  }
  openAddAnswerDlg () {
    this.addAnswerState = true
  }
  closeAddAnswerDlg () {
    this.addAnswerState = false
  }
  deleteQuestion () {
    this.$emit('deleteQuestion', this.question.id)
  }
  saveAnswer (value: string) {
    const question = {...this.question}

    question.answers.push({
      id: uuid.v1(),
      sense: this.$moment().format("X"),
      order: question.answers.length,
      value: value,
      type:'regular'
    })

    let free = question.answers.filter((el:IAnswer)=>{return el.type === 'free_text_input' || el.type === 'free_number_input'})

    if(free.length > 0)
    {
      question.answers.splice(question.answers.indexOf(free[0]),1)
      free[0].order = question.answers.length+1
      question.answers.push(free[0])
    }

    this.addAnswerState = false

    // if (question.answers.length > 5) question.type = 'catalog'



    this.$emit('clicked', question)
    this.$emit('changedQuestion')
    this.$emit('saveQuestion', question)
  }
  openBranchModal (
    title: string,
    includeQuestions: string[] | undefined,
    answerId: string
  ): void {
    this.branchQsProps.title = title
    this.branchQsProps.answerId = answerId

    if (includeQuestions) {
      this.branchQsProps.ids = includeQuestions
    }

    this.addBranchedAnswer = true
  }
  setupBranch (questions: IQuestion): void {
    this.$emit('updateQuestions', questions)
  }
  getAnswersBranchedQuestions (ids: string[] | undefined): IQuestion[] {
    if (ids) {
      return this.allQuestions.filter(v => ids.includes(v.id))
    }

    return []
  }
  clickHandler () {

    EventBus.$emit('questionBoxClicked', this.question.id)
  }
}
